document.addEventListener('DOMContentLoaded', () => {
    const freeShippingThreshold = 5000; // Free shipping threshold in cents
    const currencySymbol = '€'; // Currency symbol for formatting

    // Helper function to format money
    const formatMoney = (cents) => {
        const amount = (cents / 100).toFixed(2); // Convert cents to euros
        return `${currencySymbol}${amount.replace('.', ',')}`; // Format as €XX,XX
    };

    // Function to fetch the cart and update the free shipping message
    const updateFreeShippingMessage = () => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartTotal = cart.total_price;
                const shippingValueLeft = freeShippingThreshold - cartTotal;
                const messageElement = document.getElementById('free-shipping-message');
                
                if (shippingValueLeft > 0) {
                    messageElement.innerHTML = `
                        <p class="shipping-savings-message">
                            Je bent nog <strong>${formatMoney(shippingValueLeft)}</strong> verwijderd van <strong>GRATIS verzending</strong>!
                        </p>`;
                } else {
                    messageElement.innerHTML = `
                        <p class="shipping-savings-message">
                            Goed bezig. Je brownies worden <strong>GRATIS verzonden</strong>!
                        </p>`;
                }
            })
            .catch(error => console.error('Error fetching cart:', error));
    };

    // Function to observe cart changes
    const observeCartChanges = () => {
        const cartObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                const isCartChangeRequest = /\/cart\//.test(entry.name);

                if ( isCartChangeRequest) {
                    console.log("ITEM d");
                    updateFreeShippingMessage(); // Call update function on cart change
                }
            });
        });

        cartObserver.observe({ entryTypes: ["resource"] });
    };

    // Initialize free shipping message and start observing cart changes
    updateFreeShippingMessage();
    observeCartChanges();
   
});
